export * from './automatic.tab';
export * from './manual.tab';
